export interface CropRect {
  sx: number;
  sy: number;
  sw: number;
  sh: number;
}

/**
 * Source rectangle that gives `aspect` (width / height) with the vertical focus at `focusY` of the leftover
 * height (0 = top, 0.5 = centre). Horizontal overflow is centred.
 */
export const focusCrop = (width: number, height: number, aspect: number, focusY: number): CropRect => {
  if (width / height > aspect) {
    const sw = height * aspect;
    return { sx: (width - sw) / 2, sy: 0, sw, sh: height };
  }
  const sh = width / aspect;
  return { sx: 0, sy: (height - sh) * focusY, sw: width, sh };
};
